module.exports = __webpack_public_path__ + "img/rune-bg-dark.3f04bb65.png";